import update from 'immutability-helper';

import { Article } from '../../../../interfaces/Article';
import Store from '../../../../interfaces/Store';
import { MediaModuleColorHack } from '../../../../services/mediaModuleColorHack';

export const updateArticleColorReducer = (
  state: Store,
  { article, material, ralValue }: { article: Article; material: string; ralValue: string },
): Store => {
  const colors = article.colors.map((color) =>
    color.affectedMaterial === material ? { ...color, ralValue } : color,
  );
  const updatedArticle = { ...article, colors };

  // Apply the same color to media modules if color of support column got changed.
  // When hack is no longer needed just remove this line
  state = MediaModuleColorHack.applyOnColorChange(state, updatedArticle);

  const articles = state.configuration.articles.map((existingArticle) =>
    existingArticle.id === article.id ? updatedArticle : existingArticle,
  );

  return update(state, {
    configuration: {
      articles: {
        $set: articles,
      },
    },
  });
};
